// Hide controls and add click event listener to all video elements
document.querySelectorAll('.product-video-not-autoplay video').forEach(function(media) {
  // Hide controls
  //media.controls = false;

  // Click event listener for video playback
  media.addEventListener('click', function() {
    // Play or pause the current media
    var playButton = media.parentElement.querySelector('.product-video-central-play-button');
    
    if (media.paused || media.ended) {
      //media.play();
      playButton.classList.add('hidden');
      //media.controls = true;
    } else {
      //media.pause();
      //media.controls = false;
      playButton.classList.remove('hidden');
    }
  });
});

// Autoplay gallery videos are looping visuals. A tap must never cancel a
// native autoplay or an in-flight recovery attempt on iPhone.
document.querySelectorAll('.product-video-is-autoplay video').forEach(function(media) {
  media.addEventListener('click', function() {
    media.muted = true;
    media.defaultMuted = true;
    media.playsInline = true;
    media.play().then(function() {
      delete media.dataset.autoplayError;
    }).catch(function(error) {
      media.dataset.autoplayError = error.name;
    });
  });
});
